import React, { useRef } from "react";
import { Form } from "react-final-form";
import { get } from "lodash";
import arrayMutators from "final-form-arrays";
import {
  useTranslate,
  sanitizeEmptyValues,
  getFormInitialValues,
  useNotify,
  useDataProvider,
} from "react-admin";
import SimpleFormView from "./SimpleFormView";
import CustomFormView from "./CustomFormView";
import { postOrderItems, updateOrderItems } from "../../restClient";

const SimpleOrderForm = ({
  initialValues,
  defaultValue,
  saving,
  typePostUrl,
  ...props
}) => {
  const notify = useNotify();
  let redirect = useRef(props.redirect);
  // We don't use state here for two reasons:
  // 1. There no way to execute code only after the state has been updated
  // 2. We don't want the form to rerender when redirect is changed
  const setRedirect = (newRedirect) => {
    redirect.current = newRedirect;
  };

  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const finalInitialValues = getFormInitialValues(
    initialValues,
    defaultValue,
    props.record
  );

  const submit = (values) => {
    // const finalRedirect =
    //   typeof redirect.current === undefined ? props.redirect : redirect.current
    const finalValues = sanitizeEmptyValues(finalInitialValues, values);
    // console.log(finalValues)
    // console.log(finalRedirect)
    // props.save(finalValues, finalRedirect)

    if (get(finalValues, "orderItems[0].result.product_id", undefined)) {
      let total = 0;
      const orderItems = finalValues.orderItems.map((item, index) => {
        total = total + item.result.subtotal;
        return item.result;
      });
      // console.log(orderItems)
      if (typePostUrl && typePostUrl === "CREATE") {
        dataProvider
          .create("orders", {
            data: {
              dealer_id: 1,
              delivery_date: finalValues.delivery_date,
              total: total,
              status: "New",
            },
          })
          .then((response) => {
            if (response && response.data) {
              const dataParams = orderItems.map((product, indexx) => {
                product["order_id"] = get(response, "data.id", 0);
                return product;
              });
              // console.log(dataParams)
              postOrderItems(dataParams).then((order_items) => {
                if (order_items) {
                  // console.log(order_items)
                  notify("resources.orders.messages.element_created");
                  props.history.push("/orders");
                } else {
                  notify(
                    "resources.orders.messages.create_order_items",
                    "warning"
                  );
                }
              });
            } else {
              notify("resources.orders.messages.create_order", "warning");
            }
          });
      } else if (typePostUrl && typePostUrl === "UPDATE") {
        dataProvider
          .updte("orders", {
            id: finalValues.id,
            data: finalValues,
            previousData: finalValues,
          })
          .then((response) => {
            if (response && response.data) {
              const dataParams = orderItems.map((product, indexx) => {
                product["order_id"] = get(response, "data.id", 0);
                return product;
              });
              // console.log(dataParams)
              updateOrderItems(dataParams).then((order_items) => {
                if (order_items) {
                  console.log(order_items);
                  notify("resources.orders.messages.element_created");
                  props.history.push("/orders");
                } else {
                  notify(
                    "resources.orders.messages.create_order_items",
                    "warning"
                  );
                }
              });
            } else {
              notify("resources.orders.messages.create_order", "warning");
            }
          });
      }
    } else {
      notify("resources.orders.messages.orderItemsEmpty", "warning");
    }
  };
  const { isCustomRender, ...newProps } = props;
  return (
    <Form
      key={props.version}
      initialValues={finalInitialValues}
      onSubmit={submit}
      mutators={{
        ...arrayMutators,
        updateField: ([field, value], state, utils) => {
          utils.changeValue(state, field, () => value);
        },
      }}
      keepDirtyOnReinitialize
      destroyOnUnregister
      subscription={defaultSubscription}
      {...newProps}
      render={({
        form: {
          mutators: { updateField },
        },
        ...formProps
      }) =>
        isCustomRender ? (
          <CustomFormView
            saving={formProps.submitting || saving}
            translate={translate}
            setRedirect={setRedirect}
            {...newProps}
            {...formProps}
            updateField={(key, value) => updateField(key, value)}
          />
        ) : (
          <SimpleFormView
            saving={formProps.submitting || saving}
            translate={translate}
            setRedirect={setRedirect}
            {...newProps}
            {...formProps}
          />
        )
      }
    />
  );
};

const defaultSubscription = {
  submitting: true,
  pristine: true,
  valid: true,
  invalid: true,
};

export default SimpleOrderForm;
